import { gql, useMutation } from '@apollo/client';
import { Card, Toast, ChoiceList, Page, PageActions, TextField, Layout, Banner, List, Frame, Select, RadioButton } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';

const ReferralsForm = ({ formData, setFormData, setEditForm, refetch, formErrors, setFormErrors, saveSuccess, setSaveSuccess, i18n }) => {
    const [icon, setIcon] = useState();
    const [defaultIcon, setDefaultIcon] = useState('true');
    const [fieldError, setFieldError] = useState({ title: '', reward_value: '' });

    const ADD_REFERRAL_REWARD = gql`
        mutation($input: AddReferralRewardInput!) {
            addReferralReward(input: $input) {
                referralReward{
                    id
                    rewardType
                    rewardValue
                    appliesToCollection
                    minimumPurchasedAmount
                    discountCodePrefix
                    rewardExpiry
                }
            
            }
        }
    `;
    const [addReferralReward] = useMutation(ADD_REFERRAL_REWARD);

    const handleSubmit = () => {
        addReferralReward({
            variables: {
                input: { params: formData },
            },
        })
            .then((resp) => {
                const data = resp.data;
                const errors = data.errors;

                if (errors) {
                    setFormErrors(errors);
                } else {
                    setSaveSuccess(true);
                    setEditForm(false);
                }
            })
            .catch((error) => {
                setFormErrors(error);
            });
    }
    const [summaryText, setSummaryText] = useState([]);
    useEffect(() => {
        let summary = [];
        if (formData?.reward_type == "amount") {
            summary.push(i18n.t("points_programs.percentage_off_summary", { discount_value: formData?.reward_value }))
            summary.push(i18n.t("points_programs.applies_to_any_amount"))
        } else if (formData?.reward_type == "percentage") {
            summary.push(`${formData?.reward_value}% off entire order`)
            summary.push(i18n.t("points_programs.applies_to_any_amount"))
        } else if (formData?.reward_type == "points") {
            summary.push(i18n.t("points_programs.percentage_off_summary", { customer_points_awarded: formData?.reward_value }))
        }
        setSummaryText(summary);
        setFormData({ ...formData, summary: summary })
    }, [formData?.title, formData?.reward_value])


    const renderTextField = () => {
        return (
            <>
                {
                    formData?.reward_type == "amount" ?
                        <TextField
                            label={i18n.t('reward_value')}
                            type="number"
                            value={`${formData?.reward_value}`}
                            onChange={(e) => {
                                if (e.length > 0 && +e <= 0) {
                                    setFieldError({ ...fieldError, reward_value: "Value must be greater than 0" })
                                    setFormData({ ...formData, reward_value: "1" })
                                } else {
                                    setFieldError({ ...fieldError, reward_value: '' })
                                    setFormData({ ...formData, reward_value: `${e}` })
                                }
                            }}
                            prefix="$"
                            error={fieldError?.reward_value}
                            autoComplete="off"
                        />
                        :
                        formData?.reward_type == "percentage" ?
                            <TextField
                                label={i18n.t('reward_value')}
                                type="number"
                                value={`${formData?.reward_value}`}
                                onChange={(e) => {
                                    if (e.length > 0 && +e <= 0) {
                                        setFieldError({ ...fieldError, reward_value: "Value must be greater than 0" })
                                        setFormData({ ...formData, reward_value: "1" })
                                    } else {
                                        setFieldError({ ...fieldError, reward_value: '' })
                                        setFormData({ ...formData, reward_value: `${e}` })
                                    }
                                }}
                                suffix="% off"
                                error={fieldError?.reward_value}
                                autoComplete="off"
                            />
                            :
                            <TextField
                                label={i18n.t('points_value')}
                                type="number"
                                value={`${formData?.reward_value}`}
                                onChange={(e) => {
                                    if (e.length > 0 && +e <= 0) {
                                        setFieldError({ ...fieldError, reward_value: "Points amount must be greater than 0" })
                                        setFormData({ ...formData, reward_value: "1" })
                                    } else {
                                        setFieldError({ ...fieldError, reward_value: '' })
                                        setFormData({ ...formData, reward_value: `${e}` })
                                    }
                                }}
                                error={fieldError?.reward_value}
                                autoComplete="off"
                            />


                }
            </>
        )
    }

    const handleAppliesChange = () => {

    }
    return (
        <Frame>
            <Page
                title={i18n.t("edit")}
            >
                <Layout>
                    <Layout.Section>
                        <Card title="Reward value" sectioned>
                            <div className='earningValues'>
                                {renderTextField}
                            </div>
                        </Card>
                        {
                            formData?.reward_type != "points" && (
                                <>
                                    <Card title={i18n.t("applies_to")} sectioned>
                                        <div className='appliesTo'>
                                            <RadioButton
                                                label={i18n.t("points_programs.entire_order")}
                                                checked={'disabled'}
                                                id="disabled"
                                                name="applies_to_collection"
                                                onChange={() => handleAppliesChange()}
                                            />
                                            <RadioButton
                                                label={i18n.t("points_programs.specific_collection")}
                                                checked={'disabled'}
                                                id="disabled"
                                                name="applies_to_collection"
                                                onChange={() => handleAppliesChange()}
                                            />
                                        </div>
                                    </Card>
                                    <Card title="Minimum requirement" sectioned>
                                        <div className='appliesTo'>
                                            <RadioButton
                                                label={i18n.t("none")}
                                                checked={'disabled'}
                                                id="disabled"
                                                name="applies_to_collection"
                                                onChange={() => handleAppliesChange()}
                                            />
                                            <RadioButton
                                                label={i18n.t("points_programs.minimum_purchase_amount")}
                                                checked={'disabled'}
                                                id="disabled"
                                                name="applies_to_collection"
                                                onChange={() => handleAppliesChange()}
                                            />
                                        </div>
                                    </Card>
                                </>

                            )
                        }
                    </Layout.Section>
                    <Layout.Section secondary>
                        <Card title={i18n.t("summary")}>
                            <Card.Section>
                                <List type="bullet">
                                    {
                                        summaryText?.map((val) => {
                                            return (
                                                < List.Item >
                                                    {val}
                                                </List.Item>
                                            )
                                        })
                                    }
                                </List>
                            </Card.Section>
                        </Card>
                        <Card title={i18n.t("icon")} sectioned>
                            <ChoiceList
                                title=""
                                choices={[
                                    { label: i18n.t("default"), value: true },
                                    { label: i18n.t("points_programs.upload_own_icon"), value: false },
                                ]}
                                selected={[defaultIcon]}
                                onChange={(e) => setDefaultIcon(e)}
                            />
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <PageActions
                            primaryAction={{
                                content: i18n.t("save"),
                                onClick: () => handleSubmit()
                            }}
                            secondaryActions={[
                                {
                                    content: i18n.t("delete"),
                                    destructive: true,
                                },
                            ]}
                        />
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame >
    )
}

export default ReferralsForm;